import { useState } from 'react'
import useApi from '../../../services/useApi'

export default function useScriptOperations() {
  const [isLoading, setLoading] = useState(false)
  const Api = useApi()

  const deleteScript = (scriptId: string) => {
    return Api.delete(
      `/storefronts/script/manager/scripts/${scriptId}`,
      {},
      {
        setLoading,
        successMessage: 'Script deleted successfully',
        refetch: 'storefront-scripts-list',
      }
    )
  }

  return {
    deleteScript,
    isOperationLoading: isLoading,
  }
}
